module.exports = __webpack_public_path__ + "static/media/team_10.560c1136.jpg";